import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

import { NotificationService } from "src/app/core/notification.service";
import { WalksService } from "src/app/core/walks.service";
import { WalkHistoryDetails } from "src/app/shared/interfaces/walk-history-details";
import { WalkMemberDetails } from "src/app/shared/interfaces/walk-member-details";

import { ModalService } from "../../../core/modal.service";

@Component({
  selector: "app-edit-walk-info",
  templateUrl: "./edit-walk-info.component.html",
  styleUrls: ["./edit-walk-info.component.css"],
})
export class EditWalkInfoComponent implements OnInit {
  member: WalkMemberDetails = { MemberId: "" };
  walkHistoryRecord: WalkHistoryDetails = { MemberId: "" };
  strikeId = "";
  disableButton = false;

  minuteStep = 1;
  hourStep = 1;

  constructor(
    private walks: WalksService,
    private notificationService: NotificationService,
    private modal: ModalService,
    private datepipe: DatePipe
  ) { }

  ngOnInit() {
    this.loadMemberWalkInfo();
  }

  loadMemberWalkInfo() {
    if (this.member) {
      this.walkHistoryRecord = this.walks.getWalkInfo(this.member);
    }
  }

  async updateRecord() {
    this.notificationService.displayInfo(
      "Updating " + this.member.MemberName + " walk record",
    );

    const formattedSignInDate: string | null = this.datepipe.transform(this.walkHistoryRecord.SignInTime, "M/d/yyyy H:mm");
    const formattedSignOutDate: string | null = this.datepipe.transform(this.walkHistoryRecord.SignOutTime, "M/d/yyyy H:mm")

    const newData: WalkMemberDetails = {
      ID: this.walkHistoryRecord.ID,
      Comments: this.walkHistoryRecord.Comments,
      KickedOff: this.walkHistoryRecord.KickedOff,
      KickedOffReason: this.walkHistoryRecord.KickedOffReason,
      MemberId: this.walkHistoryRecord.MemberId,
      SignInTime: this.walkHistoryRecord.SignInTime,
      SignOutTime: this.walkHistoryRecord.SignOutTime,
      WalkDate: this.walkHistoryRecord.WalkDate,
      SignInLocalTime: formattedSignInDate,
      SignOutLocalTime: formattedSignOutDate
    }
    
    this.disableButton = true;

    const response = await this.walks.updateWalkInfo(newData);

    if (response.statusCode == 200 || response.statusCode == 201) {
      this.notificationService.displaySuccess(
        this.member.MemberName + " walk info has been updated",
      );
    } else {
      this.notificationService.displayError(response.errorMessage);
    }

    this.modal.submitClicked.next(true);

    this.disableButton = false;
    this.modal.closeModal();
  }

  cancelAction() {
    this.modal.closeModal();
  }
}
